import styles from './styles.module.scss';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const propTypes = {
  items: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
  listStyle: PropTypes.oneOf(['none', 'disc']),
  listClassName: PropTypes.string,
  itemClassName: PropTypes.string,
};
const defaultProps = {
  listStyle: 'none',
};

function PublicList(props) {
  const {items, renderItem, listStyle, listClassName, itemClassName} = props;

  const _listClassName = classNames(styles['public-list'], {
    [styles[`public-list--${listStyle}`]]: !!listStyle,
    [listClassName]: !!listClassName,
  });

  const _itemClassName = classNames(styles['public-list__item'], {
    [itemClassName]: !!itemClassName,
  });

  return (
    <ul className={_listClassName}>
      {items.map((item, index) => {
        return (
          <li key={index} className={_itemClassName}>
            {renderItem(item)}
          </li>
        );
      })}
    </ul>
  );
}

PublicList.propTypes = propTypes;
PublicList.defaultProps = defaultProps;

export default PublicList;
